// src/config/brandPresets.ts
import type { BrandPreset, BrandModeCreationType } from "../types/brand";
import type { BrandPieceKey } from "./plans"; // ✅ NUEVO

/**
 * Extiende el preset con la pieza que representa (para gating de planes).
 */
export type BrandPresetWithPiece = BrandPreset & {
  pieceKey: BrandPieceKey;
};

export const BRAND_PRESETS: Record<BrandModeCreationType, BrandPresetWithPiece> = {
  campaign_post: {
    id: "campaign_post",
    pieceKey: "post_campaign",
    title: "Post para campaña",
    subtitle: "Pieza lista para publicar: mensaje claro + estilo consistente.",
    icon: "📣",
    recommendedAspectRatio: "4:5",
    briefPlaceholders: {
      goal: "Ej: Lanzar promoción, captar leads, anunciar novedad",
      productOrTopic: "Ej: Curso de inglés, app fitness, consultoría",
      audience: "Ej: Mujeres 25-35, emprendedores, B2B startups",
    },
    outputsExamples: [
      "Post principal (hook + idea visual)",
      "Variante A/B para test",
      "Estilo consistente con tu marca",
    ],
  },

  banner: {
    id: "banner",
    pieceKey: "banner",
    title: "Banner",
    subtitle: "Ideal para landing pages, headers y secciones web.",
    icon: "🧱",
    recommendedAspectRatio: "16:9",
    briefPlaceholders: {
      goal: "Ej: Promocionar descuento, anunciar webinar, invitar a registro",
      productOrTopic: "Ej: SaaS, e-commerce, evento, servicio",
      audience: "Ej: Visitantes web, leads fríos, clientes actuales",
    },
    outputsExamples: [
      "Banner principal web",
      "Versión alternativa con otro enfoque",
      "Composición limpia orientada a conversión",
    ],
  },

  ad: {
    id: "ad",
    pieceKey: "ads",
    title: "Anuncio (Ads)",
    subtitle: "Creativo para Meta/Google: directo, claro y con intención de venta.",
    icon: "🎯",
    recommendedAspectRatio: "1:1",
    briefPlaceholders: {
      goal: "Ej: Generar ventas, captar registros, llevar tráfico",
      productOrTopic: "Ej: Producto estrella, servicio premium, oferta limitada",
      audience: "Ej: Interesados en X, retargeting, lookalikes",
    },
    outputsExamples: [
      "Creativo para ads (alta atención)",
      "Variante orientada a beneficios",
      "Variante orientada a urgencia/oferta",
    ],
  },

  product_creative: {
    id: "product_creative",
    pieceKey: "product_creative",
    title: "Creativo de producto",
    subtitle: "Visual enfocado en producto: presentación premium y vendible.",
    icon: "📦",
    recommendedAspectRatio: "1:1",
    briefPlaceholders: {
      goal: "Ej: Mostrar beneficios, destacar calidad, presentar lanzamiento",
      productOrTopic: "Ej: Proteína, skincare, gadget, infoproducto",
      audience: "Ej: Compradores nuevos, amantes del premium, nicho específico",
    },
    outputsExamples: [
      "Hero product shot (premium)",
      "Variante para e-commerce",
      "Variante para redes (más dinámica)",
    ],
  },
};

export const BRAND_PRESETS_LIST = Object.values(BRAND_PRESETS);

export function getBrandPreset(id: BrandModeCreationType) {
  return BRAND_PRESETS[id];
}

